import config from "config";

export default [
  '$rootScope',
  '$scope',
  '$window',
  '$cookies',
  '$location',
  'AuthService',
  'ErrorHandler',
  'UserDataService',
  'FacebookLoginService',
  class LoginController {
    constructor($rootScope, $scope, $window, $cookies, $location, authService, errorHandler, UserDataService, facebookService) {
      this._$rootScope = $rootScope;
      this._$window = $window;
      this._$cookies = $cookies;
      this._authService = authService;
      this._userDataService = UserDataService;
      this._errorHandler = errorHandler;
      this._userDataService = UserDataService;
      this.facebook = facebookService;

      this.rememberMe = false;
      this.showForgotPasswordModal = false;

      $scope.$on('login:open', (event, { route, email, cancelRedirect }) => {
        this.route = typeof route !== 'undefined' ? route : this.route || '/client';
        this.cancelRedirect = cancelRedirect || this.cancelRedirect || null;
        this.email = email || this.email || null;

        this.showLogin();
      });

      $scope.$on('login:close', (event, args) => {
        this.closeLogin();
      });

      $scope.$on('login:forgotPassword', e => {
        this.showForgotPasswordModal = true;
      });

      $scope.$on('cui-modal-close', () => {
        this.closeLogin();
        if (this.cancelRedirect) $window.location.href = this.cancelRedirect;
      });

      this.grecaptchaInterval = setInterval(() => {
        if (this._$window.grecaptcha && this._$window.grecaptcha.render) {
          this.recaptchaId = this._$window.grecaptcha.render('google_recaptcha_login', {
            sitekey: config.GOOGLE_RECAPTCHA_SITEKEY,
            size: 'invisible',
            callback: token => this.logIn(token),
          });

          clearInterval(this.grecaptchaInterval);

          $('.g-recaptcha-response').attr('aria-label', 'google recaptcha');
        }
      }, 100);
    }

    submitLogin(isValid) {
      if (isValid) this._$window.grecaptcha.execute(this.recaptchaId);
    }

    logIn(recaptchaToken) {
      this._$window.grecaptcha.reset(this.recaptchaId);

      this.submitState = 'loading';

      this._authService.login(this.email, this.password, this.rememberMe, recaptchaToken)
        .then((res) => this.loginSuccess(res))
        .catch((err) => this.loginError(err));
    }

    facebookLogin(authType) {
      this.facebook.login(authType)
        .then((res) => this._authService.socialLogin('facebook', this.facebook.user.authResponse.accessToken, this.facebook.user.authResponse.userID, this.userRole))
        .then((res) => this.loginSuccess(res))
        .catch((err) => {
          if (err && err.error) {
            this._errorHandler.throwError('Facebook Error', 'An error occured while attempting to create user from Facebook. Please try again later.');
          } else if (err && err.data) {
            this._errorHandler.throwError('Facebook Error', err.data.message);
          }
        });
    }

    loginSuccess(res) {
      this.submitState = 'success';
      this._userDataService.setUserData(res, true);

      if (this.route) {
        this.redirecting = true;
        if (this.route === '/client' && res.user.roles === 'CUSTOMER') {
          this.route = '/my-account';
        } else if (this.route === '/client' && res.user.roles === 'COBRAND-ADMIN') {
          this.route = '/cobrand-admin';
        } else if (this.route === '/client' && res.dashboard_link) {
          this.route = res.dashboard_link;
        }
        this._$window.location.href = this.route;
      } else {
        this.closeLogin();
        this._$rootScope.$broadcast('login:success');
      }
    }

    loginError(err) {
      this.submitState = 'error';
      let message = err && err.data && err.data.message ? err.data.message : 'Login failed, please try again.';
      this._errorHandler.throwError('Login Error', message, err ? err : {});
    }

    showRegister() {
      this.toggle = false;
      this._$rootScope.$broadcast('register:open', { cancelRedirect: this.cancelRedirect });
    }

    showLogin() {
      this.toggle = true;

      _.delay(() => {
        if (this.userRole === "CUSTOMER") $('[data-focus="password"]').focus();
        else $('[data-focus="email"]').focus();
      }, 100);
    }

    closeLogin() {
      this.toggle = false;
      this.email = '';
      this.password = '';
      this.loginForm.$setPristine();
    }
  }
];


// WEBPACK FOOTER //
// ./source/client/layout-components/account/login/login.ctrl.js